import {AddUserRoute} from "./routes/AddUser.js";
import {UserRoute} from "./routes/User.js";
import {UsersRoute} from "./routes/Users.js";
const routes = [AddUserRoute, UsersRoute, UserRoute];
export default routes;
